import React, { Component } from "react";
import PropTypes from "prop-types";

class UploadDisplay extends Component {
  clearImage = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.props.onChange({ publicUrl: "" });
    this.props.uploadedFiles.splice(0, 1);
  };

  renderFileUpload = (uploadedFile, i) => {
    const { filename, publicUrl } = uploadedFile;
    const s3Url = `https://${
      process.env.REACT_APP_IMAGE_BUCKET
    }.s3.amazonaws.com`;
    const imageUrl = `${s3Url}/${filename}`;

    return (
      <div
        key={i}
        style={{
          backgroundColor: this.props.background,
          padding: 10
        }}
      >
        <div>
          {filename ? (
            <button
              type="button"
              onClick={this.clearImage}
              style={{ position: "absolute", top: 27, left: 10 }}
            >
              X
            </button>
          ) : null}
          <img src={imageUrl} style={{ maxWidth: 600, maxHeight: 60 }} alt="" />
        </div>
        <input type="hidden" name="logoImage" value={publicUrl} />
      </div>
    );
  };

  render() {
    const { uploadedFiles } = this.props;
    return <div>{uploadedFiles.map(this.renderFileUpload)}</div>;
  }
}

UploadDisplay.propTypes = {
  uploadedFiles: PropTypes.arrayOf(PropTypes.any),
  background: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

UploadDisplay.defaultProps = {
  uploadedFiles: [],
  background: "#FFF"
};

export default UploadDisplay;
